import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// GA4 measurement ID for the thealphacpas.com property (GA account "The Alpha CPAs").
// A measurement ID is public by design: it appears in every page's source.
const GA_ID = "G-HDVJ7F1479";

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    if (!GA_ID || typeof window === "undefined") return;
    if (!window.gtag) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", GA_ID, { send_page_view: false });
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(script);
    }
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
